import getFP from "lodash/fp/get";
import get from "lodash/get";
import { useComponentDidMount } from "../../lib/hook";

export const getShowUUID = getFP("match.params.showUUID");
export const getCampaignUUID = getFP("match.params.campaignUUID");
export const getEpisodeUUID = getFP("match.params.episodeUUID");
export const getShowFromProps = props => get(props, ["shows", getShowUUID(props)]);
export const getEpisodeFromProps = props =>
  get(props, ["episodesByShowUUID", getShowUUID(props), "episodes", getEpisodeUUID(props)]);

export const useGetShow = props =>
  useComponentDidMount(() => {
    props.getShow(getShowUUID(props));
  });

export const useGetEpisode = props =>
  useComponentDidMount(() => {
    props.getEpisode(getShowUUID(props), getEpisodeUUID(props));
  });
